import {
    Button,
    FormControl,
} from "@mui/material";
import { useRef, useState } from "react";
import MultiSelectAutoComplete, { ChildComponentRef } from "shared-component/autocomplete-checkbox-multiple";
import { autoCompleteSelectOptionsFormat, selectedListValues } from "utility/helper";
import { listItemProp } from "utility/types";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { renderTimeViewClock } from "@mui/x-date-pickers/timeViewRenderers";

export interface TimeSeriesFilterComponentProps {
    vinListTimeSeries: string[];
    signalList: string[];
    setSelectedVinList: (value: any) => void;
    setSelectedVinListVisualization: (value: any) => void;
    selectedVINs: string[];
    timeSeriesTimeList?: any;
    requestTimeListTimeSeries?: any;
}

dayjs.extend(utc);

const TimeSeriesMutliFilterComponent = (props: TimeSeriesFilterComponentProps) => {
    const [vinList, setVinList] = useState<string[]>([]);
    const [signalList, setSignalList] = useState<string[]>([]);
    const [filterStartDate, setFilterStartDate] = useState<any>(dayjs(props?.requestTimeListTimeSeries![0]) || '');
    const [filterEndDate, setFilterEndDate] = useState<any>(null);
    const vinListData = props?.vinListTimeSeries;
    console.log('propppp', props)
    const childRef = useRef<ChildComponentRef>({ clearSelection: () => { } });
    const [signalSelectionLimitReached, setSignalSelectionLimitReached] = useState<boolean>(false);
    const [vinSelectionLimitReached, setVinSelectionLimitReached] = useState<boolean>(false);
    const handleSignalSelection = (selectedList: listItemProp[]) => {
        const value: string[] = selectedListValues(selectedList);
        setSignalList(
            value
        );
        setSignalSelectionLimitReached(value?.length > 5 ? true : false)
    }
    console.log(props)
    const handleVinSelection = (selectedList: listItemProp[]) => {
        const value: string[] = selectedListValues(selectedList);
        setVinList(
            value
        );
        setVinSelectionLimitReached(value?.length > 3 ? true : false)
        props?.setSelectedVinListVisualization(value);
    }

    const handleApply = () => {
        props?.setSelectedVinList({ vinList, signalList, filterStartDate, filterEndDate })
    }

    const resetSelection = () => {
        setFilterStartDate(null)
        setFilterEndDate(null)
        setVinList([])
        setSignalList([])
    }

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "row",
                width: "100%",
                height: "100%",
                justifyContent: "space-evenly",
            }}
        >
            <>
                <FormControl style={{ width: "50%" }}>
                    <MultiSelectAutoComplete
                        items={autoCompleteSelectOptionsFormat(props?.signalList)}
                        label="Select / Search Signals"
                        selectAllLabel="Select All"
                        onChange={(value: listItemProp[]) => {
                            // if (value?.length > 0) handleSignalSelection(value)
                            handleSignalSelection(value)
                        }}
                        ref={childRef}
                        selectionLimitReached={signalSelectionLimitReached}
                    />
                </FormControl>
                <FormControl style={{ minWidth: "20%" }}>
                    <MultiSelectAutoComplete
                        items={autoCompleteSelectOptionsFormat(vinListData)}
                        label="Select / Search VINS"
                        selectAllLabel="Select All"
                        onChange={(value: listItemProp[]) => {
                            // if (value?.length > 0) handleSignalSelection(value)
                            handleVinSelection(value)
                        }}
                        ref={childRef}
                        selectionLimitReached={vinSelectionLimitReached}
                        disableSelectAll={true}
                    />
                </FormControl>
                <div style={{ display: "flex", width: '100%' }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DateTimePicker
                            sx={{ paddingLeft: '8px' }}
                            label="Start Date/Time"
                            viewRenderers={{
                                hours: renderTimeViewClock,
                                minutes: renderTimeViewClock,
                                seconds: renderTimeViewClock,
                            }}
                            value={dayjs(filterStartDate)}
                            slotProps={{ textField: { fullWidth: true, required: true } }}
                            minDate={props?.timeSeriesTimeList?.minTimestamp?.length > 0 && props?.timeSeriesTimeList?.minTimestamp![0] ? dayjs(props?.timeSeriesTimeList?.minTimestamp![0]) : null}
                            maxDate={props?.timeSeriesTimeList?.maxTimestamp?.length > 0 && props?.timeSeriesTimeList?.maxTimestamp![0] ? dayjs(props?.timeSeriesTimeList?.maxTimestamp![0]) : null}
                            onChange={(newValue: any) => {
                                setFilterStartDate(newValue)
                            }}
                        />
                        <DateTimePicker
                            sx={{ paddingLeft: '8px' }}
                            label="End Date/Time"
                            viewRenderers={{
                                hours: renderTimeViewClock,
                                minutes: renderTimeViewClock,
                                seconds: renderTimeViewClock,
                            }}
                            value={dayjs(filterEndDate)}
                            minDate={filterStartDate ? dayjs(filterStartDate) : null}
                            maxDate={filterStartDate ? dayjs(filterStartDate).add(1, 'day') : dayjs(new Date())}
                            onChange={(newValue: any) => {
                                setFilterEndDate(newValue)
                            }}
                            slotProps={{ textField: { fullWidth: true, required: true } }}
                        />
                    </LocalizationProvider>
                </div>
            </>
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                }}
            >
                <Button
                    variant="contained"
                    onClick={() => {
                        handleApply()
                    }}
                    size="small"
                    sx={{ height: '36px', margin:'8px' }}
                    disabled={signalList?.length === 0 || filterEndDate === null || filterStartDate === null || vinList?.length === 0}
                >
                    APPLY
                </Button>
                <Button
                    variant="contained"
                    onClick={() => {
                        resetSelection()
                    }}
                    size="small"
                    sx={{ height: '36px', margin:'8px' }}
                >
                    RESET
                </Button>
            </div>
        </div>
    );
};

export default TimeSeriesMutliFilterComponent;
